import { Fragment, FunctionComponent, useEffect } from 'react';
import { useGlobalDispatch } from '../../common/context/AppContext';

//Mock view to handle page refresh
const MockRouteViewScreen: FunctionComponent = (): JSX.Element => {
  const appDispatch = useGlobalDispatch();

  useEffect(() => {
    appDispatch({ hasError: { stepOne: true, stepTwo: false } });
  }, [appDispatch]);

  return <Fragment />;
};

export default MockRouteViewScreen;
